export default __webpack_public_path__ + "2b1bc24e6cfa5ac5e592ccf184ed895d.png";